/* eslint-disable no-unused-vars */
import { FormStatus } from '@/constants/form/FormStatus'
import FormDefinition from './formDefinition'

/**
 * Creates an instance of FormSchema.
 * @typedef {Object} FormSchemaType
 * @property {number} id - The unique identifier for the form.
 * @property {Date} createdDateUTC - The UTC timestamp when the form was created.
 * @property {?string} createdBy - The creator of the form (nullable).
 * @property {?Date} lastModifiedDateUTC - The UTC timestamp when the form was last modified (nullable).
 * @property {?string} lastModifiedBy - The last user who modified the form (nullable).
 * @property {number} versionNo - The version number of the form.
 * @property {string} name - The name of the form.
 * @property {string} description - A description of the form.
 * @property {FormStatus} status - The status of the form (e.g., "Active", "Inactive", etc.).
 * @property {FormDefinition} formDefinition - The definition of the form.
 */

/**
 * Represents a form schema.
 * @class
 */
export default class FormSchema {
  /**
   * Create a new FormSchema.
   * @param {FormSchemaType} params
   */
  constructor(params) {
    this.id = params.id
    this.createdDateUTC = params.createdDateUTC
    this.createdBy = params.createdBy
    this.lastModifiedDateUTC = params.lastModifiedDateUTC
    this.lastModifiedBy = params.lastModifiedBy
    this.versionNo = params.versionNo
    this.name = params.name
    this.description = params.description
    this.status = params.status
    this.formDefinition = params.formDefinition
      ? new FormDefinition(params.formDefinition)
      : null
  }
}
